import React from 'react';
import { connect } from 'react-redux';
import { states } from '@/constants/lifecycle';
import FormValidationError from '@/components/errors/FormValidationError';
import CohortQueriesDropdown from '@/cohorts/queries/components/CohortQueriesDropdown';
import fetch from '../hooks/fetch';
import { fetchRequestQueries, updateRequestQueries } from '../actions';
import { newRequest, resolveRequestWorkflow } from '../../state/state';

const RequestCohortsDropdown = ({
  category,
  code,
  cohortCode,
  saveStatus,
  fetchData,
  queries,
  readStatus,
  updateCohort,
}) => {
  fetch.useFetchRequestQueries(fetchData, category, code, cohortCode, readStatus);
  return (
    <FormValidationError htmlFor="queries" labelId="access.queries">
      <CohortQueriesDropdown
        id="queries"
        disabled={saveStatus === states.PENDING}
        message="access.queries.placeholder"
        onChange={(e, { value }) => { updateCohort(category, code, value); }}
        readStatus={readStatus}
        queries={queries}
        className="aridhia-queries-dropdown"
        byId
      />
    </FormValidationError>
  );
};

const mapStateToProps = ({
  requests: { requests },
  workflows: { workflows },
}, ownProps) => {
  const { request, source } = resolveRequestWorkflow(requests, workflows, ownProps, newRequest(ownProps));
  const safeSource = source || { code: null };

  return ({
    cohortCode: safeSource.code,
    queries: safeSource.queries || [],
    readErrors: safeSource.readErrors,
    readStatus: safeSource.readStatus,
    saveStatus: request.saveStatus,
  });
};

const mapDispatchToProps = {
  updateCohort: updateRequestQueries,
  fetchData: fetchRequestQueries,
};

export default connect(mapStateToProps, mapDispatchToProps)(RequestCohortsDropdown);
